import 'formdata-polyfill'; // import FormData into global. FormData does not work in safari worker
import { addTextColor } from '../../post-page/actions/rce-settings';
import { search, clearSearchResults } from '../../search/actions/search';
import { publishPostPromisified } from '../actions/publish-post';
import { saveAndPublishPostPromisified } from '../actions/save-and-publish-post';
import { savePostDraftPromisified } from '../actions/save-post-draft';
import { submitPostForModerationPromisified } from '../actions/submit-post-for-moderation';
import { uploadImagePromisified } from '../actions/upload-image-new';
import {
  requestFileUploadUrlPromisified,
  requestFileDownloadUrlPromisified,
} from '../actions/wix-media';
import { incrementPostLikeCount } from '../store/post-likes/post-likes-actions';
import { openPostSettings } from '../store/post-settings/open-post-settings';

export default {
  uploadImagePromisified,
  saveAndPublishPostPromisified,
  addTextColor,
  incrementPostLikeCount,
  publishPostPromisified,
  savePostDraftPromisified,
  openPostSettings,
  requestFileUploadUrlPromisified,
  requestFileDownloadUrlPromisified,
  search,
  clearSearchResults,
  submitPostForModerationPromisified,
};
